import { render, staticRenderFns } from "./miniLists.vue?vue&type=template&id=1378a953&scoped=true&"
import script from "./miniLists.vue?vue&type=script&lang=js&"
export * from "./miniLists.vue?vue&type=script&lang=js&"
import style0 from "./miniLists.vue?vue&type=style&index=0&id=1378a953&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1378a953",
  null
  
)

export default component.exports